<template>
  <mdicon :name="name" :size="size" class="transition-colors duration-200" />
</template>

<script setup>
defineProps({
  name: {
    type: String,
    required: true,
  },
  size: {
    type: Number,
    default: 20,
  },
})
</script>
